import BaseBlockContent from '@sanity/block-content-to-react'
import React from 'react'

import { getBlockQuoteIcon } from '../../lib/blockQuoteIcons'
import { cn, getBlockQuoteType, getHeadingId } from '../../lib/helpers'
import typography from '../typography.module.css'
import CodeBlock from './codeBlock'
import Figure from './figure'
import HeadingLink from './headingLink'
import InternalLink from './internalLink'
import OutboundLink from './outboundLink'
import Slideshow from './slideshow'
import VideoAnimation from './videoAnimation'
import YouTubeEmbed from './youTubeEmbed'

// TODO When one or more headings already exist with the same ID, increment it
// i.e. heading-id, heading-id1, heading-id2,
// TODO differentiate by page when rendering BlockContent within article pages,
// and count each heading being created

const serializers = {
  // ? marks docs: https://github.com/sanity-io/block-content-to-react#rendering-custom-marks
  marks: {
    keyboard: ({ children }) => <kbd className={typography.keyboard}>{children}</kbd>,
    link: OutboundLink,
    internalLink: InternalLink
  },
  types: {
    block (props) {
      switch (props.node.style) {
        case 'h1':
          return <h1 className={typography.responsiveTitle1}>{props.children}</h1>

        case 'h2':
          return (
            <h2 id={getHeadingId(props)} className={typography.responsiveTitle2}>
              {props.children}
              <HeadingLink data={props} />
            </h2>
          )

        case 'h3':
          return (
            <h3 id={getHeadingId(props)} className={typography.responsiveTitle3}>
              {props.children}
              <HeadingLink data={props} />
            </h3>
          )

        case 'h4':
          return (
            <h4 id={getHeadingId(props)} className={typography.responsiveTitle4}>
              {props.children}
              <HeadingLink data={props} />
            </h4>
          )

        case 'blockquote':
          return (
            <blockquote className={cn(typography.blockQuote, typography[getBlockQuoteType(props)])}>
              {getBlockQuoteIcon(props)()}
              {props.children}
            </blockquote>
          )
        default:
          return <p className={typography.paragraph}>{props.children}</p>
      }
    },
    code (props) {
      return <CodeBlock {...props.node} />
    },
    figure (props) {
      return <Figure {...props.node} />
    },
    video (props) {
      return <VideoAnimation {...props.node} />
    },
    youtube (props) {
      return <YouTubeEmbed {...props.node} />
    },
    slideshow (props) {
      return <Slideshow {...props.node} />
    }
  },
  listItem (props) {
    return <li className='custom-marker'>{props.children}</li>
  }
}

const BlockContent = ({ blocks }) => <BaseBlockContent blocks={blocks} serializers={serializers} />

export default BlockContent
